/* eslint-disable import/no-named-default,@typescript-eslint/no-explicit-any */
import {
    default as ActiveIcon,
    default as SelectedActiveIcon
} from 'Resources/Images/CctvIcons/cctv-active.png';
import {
    default as OutOfServiceIcon,
    default as SelectedOutOfServiceIcon
} from 'Resources/Images/CctvIcons/cctv-oos.png';
import {
    default as ErrorIcon,
    default as SelectedErrorIcon
} from 'Resources/Images/CctvIcons/cctv-error.png';
import {
    default as FailedIcon,
    default as SelectedFailedIcon
} from 'Resources/Images/CctvIcons/cctv-failed.png';
import { OpStatus } from 'NSwag/ServerClient/Client.nswag';

interface IOptions {
    unselected: any;
    selected: any;
}

type IIconMap = Map<OpStatus, IOptions>;

/**
 * Maps all OpStatus enum values to their associated icon.
 */
const iconMapping: IIconMap = new Map<OpStatus, IOptions>([
    [OpStatus.NULL, {
        unselected: OutOfServiceIcon,
        selected: SelectedOutOfServiceIcon
    }],
    [OpStatus.NotSet, {
        unselected: OutOfServiceIcon,
        selected: SelectedOutOfServiceIcon
    }],
    [OpStatus.Active, {
        unselected: ActiveIcon,
        selected: SelectedActiveIcon
    }],
    [OpStatus.Error, {
        unselected: ErrorIcon,
        selected: SelectedErrorIcon
    }],
    [OpStatus.Failed, {
        unselected: FailedIcon,
        selected: SelectedFailedIcon
    }],
    [OpStatus.OutOfService, {
        unselected: OutOfServiceIcon,
        selected: SelectedOutOfServiceIcon
    }]
]);

/**
 * Takes in an OpStatus for a detector and returns the associated icon
 * @param opStatus - Current status of the Camera
 * @param selected - True if the camera is currently selected, defaults to false
 */
export const getCameraIcon = (opStatus: OpStatus, selected = false): string => {
    let icons = iconMapping.get(opStatus);

    if (icons == null) {
        icons = iconMapping.get(OpStatus.NULL);
    }

    if (icons == null) {
        return '';
    }

    return selected ? icons.selected : icons.unselected;
};
